import React from 'react';
import { Delete } from '@mui/icons-material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Button } from '@mui/material';

import InputField from './InputField';

function QualificationsField({
  value = [],
  onChange,
  label = 'Qualifications',
  required = false,
  minItems = 1,
}) {
  const qualifications = Array.isArray(value) ? value : [];

  const addQualification = () => {
    onChange([...qualifications, { degree: '', institution: '' }]);
  };

  const removeQualification = (index) => {
    if (qualifications.length > minItems) {
      onChange(qualifications.filter((_, i) => i !== index));
    }
  };

  const updateQualification = (index, field, fieldValue) => {
    const updated = [...qualifications];
    updated[index][field] = fieldValue;
    onChange(updated);
  };

  return (
    <div className="space-y-3">
      {/* Label on top */}
      <label className="text-white font-medium">
        {label} {required && <span className="text-red-400">*</span>}
      </label>

      {/* Qualification cards */}
      {qualifications.map((qual, index) => (
        <div
          key={index}
          className="bg-gradient-glass p-4 rounded-lg space-y-4 border border-white/10"
        >
          <InputField
            label="Master/Degree/Diploma"
            fullWidth
            required
            value={qual.degree}
            onChange={(e) => updateQualification(index, 'degree', e.target.value)}
            placeholder="e.g., Bachelor of Science"
          />
          <InputField
            label="Institution"
            fullWidth
            required
            value={qual.institution}
            onChange={(e) => updateQualification(index, 'institution', e.target.value)}
            placeholder="e.g., University of Colombo"
          />
          {qualifications.length > minItems && (
            <Button
              size="small"
              color="error"
              onClick={() => removeQualification(index)}
              startIcon={<Delete />}
              sx={{ textTransform: 'none' }}
            >
              Remove
            </Button>
          )}
        </div>
      ))}

      {/* Add button at the bottom */}
      <button
        type="button"
        onClick={addQualification}
        className="w-full flex items-center justify-center gap-2 py-2.5 rounded-lg border border-dashed border-orange-500/40 text-orange-400 hover:bg-orange-500/10 transition text-sm font-medium"
      >
        <AddCircleOutlineIcon fontSize="small" />
        Add Qualification
      </button>
    </div>
  );
}

export default QualificationsField;
